export const COOKIE_NAMES = {
  AUTH_TOKEN: 'aiChatbotToken',
  USER: 'aiChatbotUser',
};

export const APP_CONSTANTS = {
  TITLE: 'AI Chatbot',
  COOKIE_NAMES,
};
